// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36pqf","question":"styles_question__7D61a","inputVisibleButton":"styles_inputVisibleButton__3jcF-","note":"styles_note__1UrMs"};